import type { DrishtiHit, PlanetPosition } from '@astrally/shared';
import { signCount } from '../core/zodiac.js';

/**
 * Graha drishti (sign-to-sign full aspects).
 * Every graha aspects the 7th from itself; Mars adds 4/8, Jupiter 5/9,
 * Saturn 3/10. Computed for the seven classical grahas (node drishti is
 * tradition-dependent and intentionally omitted in v1).
 */

const SPECIAL: Record<string, number[]> = {
  mars: [4, 8],
  jupiter: [5, 9],
  saturn: [3, 10],
};

const DRISHTI_GRAHAS = ['sun', 'moon', 'mars', 'mercury', 'jupiter', 'venus', 'saturn'] as const;

export function computeDrishti(positions: PlanetPosition[]): DrishtiHit[] {
  const hits: DrishtiHit[] = [];
  const bySign = positions.filter((p) =>
    (DRISHTI_GRAHAS as readonly string[]).includes(p.planet),
  );
  for (const from of bySign) {
    const offsets = [7, ...(SPECIAL[from.planet] ?? [])];
    for (const to of bySign) {
      if (to.planet === from.planet) continue;
      const offset = signCount(from.sidereal.sign, to.sidereal.sign);
      if (offsets.includes(offset)) {
        hits.push({
          from: from.planet,
          to: to.planet,
          houseOffset: offset,
          special: offset !== 7,
        });
      }
    }
  }
  return hits;
}
